<router-outlet (load)="onLoad()"></router-outlet>
<ngx-spinner></ngx-spinner>